















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class Page extends Vue {
  @Prop({ type: String, required: true }) title?: string
  @Prop({ type: String, required: false, default: 'mb-3' }) titleClass?: string
}
